import { useEffect, useState } from 'react';
import timesheetService from '../../../../services/TimesheetService';
import { getFormattedTableRows } from '../../../MyTime/table/helpers';
import { addDays, format } from 'date-fns';

export default function useTimesheetFilter(filter) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchAllTimesheet = async () => {
      try {
        setLoading(true);
        setError(null);

        const timesheetRecords = await timesheetService.listAllTimesheet();
        const formattedTimesheet = getFormattedTableRows(timesheetRecords.data.data);

        const filteredRows = formattedTimesheet.filter((row) => {
          if (filter.timesheetStatus !== 'All') {
            if (
              filter.timesheetStatus === row.status &&
              (filter.startDate === null || new Date(row.Date) >= new Date(filter.startDate).getTime()) &&
              new Date(row.Date) <= addDays(new Date(filter.endDate), 1).getTime()
            ) {
              return true;
            }

            return false;
          }

          if (filter.timesheetPeriod === 'All') return true;

          if (
            (filter.startDate === null || new Date(row.Date) >= new Date(filter.startDate).getTime()) &&
            new Date(row.Date) <= addDays(new Date(filter.endDate), 1).getTime()
          ) {
            return true;
          }

          return false;
        });

        const dateFormattedRows = filteredRows.map((r) => {
          return {
            ...r,
            Day: format(new Date(r.Date), 'EEEE'),
            Date: format(new Date(r.Date), 'dd/MM/yyyy')
          };
        });

        const searchedRows = searchRows(dateFormattedRows, filter.searchQuery);

        const dateFormatSearchedRows = searchedRows.map((sr) => {
          const matchedRow = filteredRows.find((fr) => fr.id === sr.id);

          if (matchedRow) {
            return { ...sr, Date: matchedRow.Date };
          } else {
            return sr;
          }
        });

        setRows(dateFormatSearchedRows);
      } catch (error) {
        setError(error.message || 'Could not fetch all timesheet data');
      } finally {
        setLoading(false);
      }
    };

    fetchAllTimesheet();
  }, [filter.endDate, filter.startDate, filter.timesheetStatus, filter.timesheetPeriod, filter.searchQuery]);
  return { rows, setRows, error, loading };
}

function searchRows(allRows, query) {
  const normalizedQuery = query.trim().toLowerCase();
  const containsQuery = (value) =>
    String(value ?? '')
      .toLowerCase()
      .includes(normalizedQuery);

  const searchedRows = allRows.filter((r) => {
    return (
      containsQuery(r.Date) ||
      containsQuery(r.Day) ||
      containsQuery(r.CustomerRef?.name) ||
      containsQuery(r.EmployeeRef?.name) ||
      containsQuery(r.status) ||
      containsQuery(r.variationNote) ||
      containsQuery(r.Description) ||
      containsQuery(r.ClassRef?.name) ||
      containsQuery(r.VendorRef?.name)
    );
  });

  return searchedRows;
}
